import { UserProfile } from '@euler/model';
import { OrgUserRoleType, StoreFeature } from '@euler/model/enum';
import { storeFeatureAccessOf } from './entitlements/storeFeatureAccess';
import { roleStringToUserRoles } from './orgUserUtils';

/**
 * Who may redeem a customer's coupon at the counter. Mirrors the server's
 * role list exactly, so the app never offers a redemption it refuses.
 */
export function canRedeemApdmCoupons(profile: UserProfile | null): boolean {
  if (
    !profile?.user.enabled ||
    !storeFeatureAccessOf(profile.entitlements, StoreFeature.Apdm).enabled
  )
    return false;
  return roleStringToUserRoles(profile.user.role).some(role =>
    [
      OrgUserRoleType.Manager,
      OrgUserRoleType.ServiceAgents,
      OrgUserRoleType.Marketer,
    ].includes(role),
  );
}

export function canManageApdmImports(profile: UserProfile | null): boolean {
  if (
    !profile?.user.enabled ||
    !storeFeatureAccessOf(profile.entitlements, StoreFeature.Apdm).enabled
  )
    return false;
  if (profile.user.isOrgRootUser === true) return true;
  return roleStringToUserRoles(profile.user.role).some(role =>
    [
      OrgUserRoleType.Administrator,
      OrgUserRoleType.Manager,
      OrgUserRoleType.Marketer,
    ].includes(role),
  );
}
